import React from "react"
import { useState } from 'react';

import theme from '../../../../config/theme';

import { chevronDown } from 'react-icons-kit/feather';
import Icon from 'react-icons-kit';
import { chevronUp } from 'react-icons-kit/feather';
import CheckboxFilterBlock from './CheckboxFilterBlock';
import CategoryFilterBlock from './CategoryFilterBlock';

const ShowMore = (props) => {
    return (
        <div className="show-more" onClick={props.toggleMore}>
            <style jsx>{`
                .show-more {
                    cursor: pointer;
                    color: ${theme.colors.gradients.blueA};
                    text-align: center;
                    padding: 5px;
                    margin-bottom: 5px;
                }
            `}</style>

            Vezi mai {props.expanded === true ? 'putine' : 'multe'} <Icon size={16} icon={props.expanded ? chevronUp : chevronDown}/>
        </div>
    )
}

export default ShowMore;